import { Field, Form, FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { FaEye, FaDownload, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { CollegeReport } from "../UniversityScreens/CollegeReport";
import { openScrutinyPdfInNewTab } from "../UniversityScreens/ScrutinityPdfGeneration";
import { openChangeOfManagementPdfInNewTab } from "../UniversityScreens/PdfForChangeofManagement";
import { viewImage } from "../../CommonUtils/viewImage";
import { AiOutlineSignature } from "react-icons/ai";
import { openBase64Pdf } from "../../CommonUtils/ImagesBase64";
import { getNocFullName, initiateESign } from "../../CommonUtils/CommonValidations";
import { digisignFunction } from "../../CommonUtils/DIGISIGN/digisignFunction";
import { useSelector } from "react-redux";
import { DashBoardCounts } from "../../Reducers/AffiliationCommonservice";

export default function DeficiencyFinalStatus() {

  const Dashboardcounts = useSelector((state) => state?.commonMastersReducer?.DashboardCounts);
  const [selectedDefRow, setSelectedDefRow] = useState(null);
  const [showDefShiftingModal, setShowDefShiftingModal] = useState(false);
  const [selectedCollegeCode, setSelectedCollegeCode] = useState(null);
  const [pdfData, setPdfData1] = useState({});
  const [societyName, setSocietyName] = useState([]);
  const [managementData, setManagementData] = useState([]);
  const [nocdata, setNocdata] = useState({});
  const [selectedDigii, setSelectedDigii] = useState(null);

  const [pdfDataa, setPdfDataa] = useState({});
  const [pdfData3, setPdfData3] = useState({});
  const [ScrutinyPdfData, setScrutinyPdfData] = useState({});
  const [ScrutinyPdfData1, setScrutinyPdfData1] = useState({});
  const [showPdffModal, setShowPdffModal] = useState(false);
  const [pdfBas64, setPdfBas64] = useState("");
  let navigate = useNavigate();
  const userId = sessionStorage.getItem("user_id");

  // ********** socity details***************
  function getShiftingScrutinyyDetails(collCode, nocType) {
    let url = config.url.FAC_URL + `getScrutinyDetails/${collCode}/${nocType}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          setPdfData1(res.data);
        } else {
          setPdfData1({});
        }
      })
      .catch((e) => {
        setPdfData1({});
      });
  }
  const [getOverallData, setOverallData] = useState([]);
  function finalGetAfterrSubmit(collCode) {
    let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        const data = res?.data?.data;
        if (data && data.length > 0) {
          setPdfDataa(data);
          setOverallData(res.data);

        } else {
          setOverallData([]);
        }
      })
      .catch((error) => { });
  }

  function getShiftingAddDetails() {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const shiftData = res.data.data || [];

          if (shiftData.length > 0) {
            setPdfData3(res.data);
          }
        } else {
          setPdfData3({});
        }
      })
      .catch((err) => { });
  }

  const iconBtn = {
    border: "none",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const previewBtn = {
    ...iconBtn,
    backgroundColor: "#e0f2fe",
    color: "#0284c7",
  };


  function getProceedingsDetailss(collCode, nocType, jdstatus) {

    const type = nocType?.toLowerCase();
    const status = jdstatus?.toLowerCase();

    let url;

    if (jdstatus === "Deficiencies Identified") {
      url = `${config.url.FAC_URL}generateDeficiencyPdf/${collCode}/${nocType}`;
    }
    else if (
      type === "management" &&
      (status === "approved" || status === "conditionally approved")
    ) {
      url = `${config.url.FAC_URL}managementproceedings/${collCode}/${nocType}`;
    }
    else if (type === "shifting") {
      url = `${config.url.FAC_URL}shiftingproceedings/${collCode}/${nocType}`;
    }
    else if (
      type === "eop" &&
      (status === "approved" || status === "conditionally approved")
    ) {
      url = `${config.url.FAC_URL}eopproceedings/${collCode}/${nocType}`;
    }
    console.log("URL for proceedings PDF:", url);
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.scode === "01" && res?.data?.pdf) {
          setPdfBas64(res.data.pdf);
          setShowPdffModal(true);
        } else {
          failureAlert("PDF not available.");
        }
      })
      .catch((err) => {
        console.error("Error fetching PDF:", err);
        failureAlert("Failed to load PDF.");
      });
  }

  const EopfetchDeficiencies = async (collCode) => {
    try {
      let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`;
      const res = await CommonAxiosGet(url);
      if (res && res.data && res.data.status === true && res.data.def) {
        if (Array.isArray(res.data.def)) {
          const mappedData = res.data.def.map((item, index) => {
            return {
              remarks: item.remarks || item.deficiency_description || item.deficiency,
            };
          });

          // console.log("Mapped deficiencies:", mappedData);
          return mappedData;
        } else {
          // console.log("def is not an array, it's:", typeof res.data.def);
          return [];
        }
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error in EopfetchDeficiencies:", error);
      return [];
    }
  };

  function getInspectionPdf(collCode, nocType) {
    console.log("(collCode, nocType", collCode, nocType);

    CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDetailspdf/${collCode}/${nocType}`).then((res) => {
      if (res?.data?.pdf) {
        console.log("ress", res);

        openBase64Pdf(res?.data?.pdf);
      }
    });
  }
  async function openNewCollegeScrutinyyPdf(row) {
    const collCode = row?.coll_code;
    if (!collCode) {
      failureAlert("College code not found. Please login again.");
      return;
    }
    const previewWindow = window.open("", "_blank");
    if (!previewWindow) {
      failureAlert("Popup blocked. Please allow popups to preview the PDF.");
      return;
    }
    previewWindow.document.write("<title>Generating PDF...</title><p style='font-family: Arial, sans-serif; padding: 24px;'>Generating scrutiny report PDF...</p>");
    try {
      const [collegeResponse, scrutinyResponse] = await Promise.all([
        CommonAxiosGet(`${config.url.FAC_URL}getCollegeDetailsById?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDataForNewAc?collCode=${collCode}`),
      ]);

      const clgDetails = collegeResponse?.data || {};
      const scrutinyData = scrutinyResponse?.data || {};

      setScrutinyPdfData(clgDetails);
      setScrutinyPdfData1(scrutinyData);
      setSelectedDefRow(row);

      await openScrutinyPdfInNewTab({ clgDetails, scrutinyData, rowData: row, previewWindow });
    } catch (error) {
      previewWindow.close();
      console.error("Failed to open scrutiny report PDF", error);
      failureAlert("Failed to generate scrutiny report PDF.");
    }
  }

  async function openManagementScrutinyPdf(row) {
    const collCode = row?.coll_code;
    if (!collCode) {
      failureAlert("College code not found. Please login again.");
      return;
    }

    const previewWindow = window.open("", "_blank");
    if (!previewWindow) {
      failureAlert("Popup blocked. Please allow popups to preview the PDF.");
      return;
    }

    previewWindow.document.write("<title>Generating PDF...</title><p style='font-family: Arial, sans-serif; padding: 24px;'>Generating management scrutiny report PDF...</p>");

    try {
      const [collegeResponse, societyResponse, accommodationResponse, managementResponse, previewResponse, scrutinyDetailsResponse] = await Promise.all([
        CommonAxiosGet(`${config.url.FAC_URL}getCollegeDetailsById?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getSocietyNameChangeinspection/${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getAccommodationAreaData/${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getManagementScrutiny?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getPreView?collCode=${collCode}&nocType=management`),
        CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDetails/${collCode}/management`),
      ]);

      const collegeData = collegeResponse?.data || {};
      const societyData = societyResponse?.data?.societyName_status === true ? societyResponse?.data?.societyName || [] : [];
      const accommodationData = accommodationResponse?.data?.status === true ? accommodationResponse?.data?.data || [] : [];
      const managementPayload = managementResponse?.data?.scode === "01" ? managementResponse?.data || {} : {};
      const previewData = previewResponse?.data?.scode === "01" ? previewResponse?.data || {} : {};
      const scrutinyDetails = scrutinyDetailsResponse?.data?.status === true ? scrutinyDetailsResponse?.data || {} : {};

      setPdfData1(collegeData);
      setSocietyName(societyData);
      setAccom(accommodationData);
      setManagementData(managementPayload);
      setNocdata(previewData);
      setSelectedDefRow(row);

      await openChangeOfManagementPdfInNewTab({
        collCode,
        societyName: societyData,
        formValues: {},
        managementData: managementPayload,
        scrutinyDetails,
        mngmtScrutiny: managementPayload?.mngmtScrutiny || [],
        deficiencies: managementPayload?.mngmtScrutiny_def || [],
        accommodationRows: managementPayload?.mngmtScrutiny_accom || [],
        accommodationBaseRows: accommodationData,
        corpusFundInstall: scrutinyDetails?.corpusFundInstall || [],
        ugPrograms: scrutinyDetails?.ugCourses || [],
        pgPrograms: scrutinyDetails?.pgCourses || [],
        ugCorpusFunds: [],
        pgBefore: [],
        pgCorpusFunds: [],
        nocdata: previewData,
        apiValues: collegeData,
        parking: {},
        previewWindow,
      });
    } catch (error) {
      previewWindow.close();
      console.error("Failed to open management scrutiny report PDF", error);
      failureAlert("Failed to generate management scrutiny report PDF.");
    }
  }

  function getGovtStatusFile(row) {
    return row?.final_pdf_sign || "";
  }

  function hasGovtStatusFile(row) {
    const govtStatusFile = getGovtStatusFile(row);
    return govtStatusFile !== null && govtStatusFile !== undefined && String(govtStatusFile).trim() !== "";
  }

  function handlePost(row, index) {
    const rowValues = degreeUniFormik.values?.collegesTableData?.[index] || {};
    const govtFile = rowValues.govtFile || null;
    const isJdAdmin = userId === "jd_admin";
    const isSectionAdmin = userId === "section_admin";

    let payload;

    if (isSectionAdmin) {
      payload = {
        collCode: row.coll_code || "",
        nocType: row.noc_type || "",
        finalStatus: "Approved",
        finalPdf: row.final_pdf_sign,
        finalPdfSign: govtFile,
      };
    } else {
      payload = {
        collCode: row.coll_code || "",
        nocType: row.noc_type || "",
        inspectionStatus: row.final_status || "",
        jdStatus: rowValues.jdStatus || "",
      };
    }

    if (isJdAdmin && !payload.jdStatus) {
      failureAlert("Please select JD Status");
      return;
    }

    const endpoint = userId === "section_admin" ? "updatesectionstatus" : "updatejdstatus";
    CommonAxiosPost(`${config.url.FAC_URL}${endpoint}`, payload)
      .then((res) => {
        if (res?.data?.ResponseCode === "01" || res?.data?.status === true) {
          successAlert2(res?.data?.ResponseDesc || "Submitted successfully");
          GetInspectionStatus();
          degreeUniFormik.setFieldValue("collegesTableData", []);
        } else {
          failureAlert(res?.data?.sdesc || "Failed to submit");
        }
      })
      .catch(() => {
        failureAlert("Something went wrong!");
      });
  }

  const Columns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "coll_code",
      header: "College Code",
      accessorKey: "coll_code",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "inst_name",
      header: "College Name",
      accessorKey: "inst_name",
      cell: ({ row }) => <div style={{ textAlign: "left" }}>{row.original.inst_name}</div>,
    },
    {
      id: "mobile_email",
      header: "Contact Details",
      cell: ({ row }) => (
        <div style={{ textAlign: "left" }}>
          {row.original.mobile_no} <br /> {row.original.email}
        </div>
      ),
    },
    // {
    //   id: "noc_type",
    //   header: "NOC Type",
    //   accessorKey: "noc_type",
    //   meta: { style: { textAlign: "center" } },
    // },

    {
      id: "college_preview",
      header: "College Preview",
      enableExport: false,

      cell: ({ row }) => {
        const clgcode = row.original;

        return (
          <button style={previewBtn} title="View College" onClick={() => navigate("/CollegeDetails", { state: { clgcode } })}>
            <FaEye />
          </button>
        );
      },
    },
    {
      id: "inspection_preview",
      header: "Inspection Preview",
      enableExport: false,

      cell: ({ row }) => {
        const nocType = row.original.noc_type?.toLowerCase();
        const collCode = row.original.coll_code;

        const isShifting = nocType === "shifting";
        const isEOP = nocType === "eop";
        const isNewCollege = nocType === "new_college";
        const isManagement = nocType === "management";

        const handleView = async () => {
          if (isShifting) {
            // 🔹 Shifting logic
            setSelectedCollegeCode(collCode);
            setShowDefShiftingModal(true);
            getShiftingScrutinyyDetails(collCode, nocType);
            finalGetAfterrSubmit(collCode);
            setSelectedDefRow(row.original);
            getShiftingAddDetailsss(collCode);
            getSurveyNumberr(collCode);
          } else if (isEOP) {
            // 🔹 EOP logic (PDF)
            getInspectionPdf(collCode, nocType);
          } else if (isNewCollege) {
            openNewCollegeScrutinyyPdf(row.original);
          } else if (isManagement) {
            openManagementScrutinyPdf(row.original);
          } else {
            setSelectedDefRow(row.original);
          }
        };

        return (
          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
            <button
              style={previewBtn}
              onClick={handleView}
              title={isShifting ? "View Shifting Scrutiny" : isEOP ? "View Inspection PDF" : isManagement ? "View Management Scrutiny" : "View Inspection"}
            >
              <FaEye />
            </button>
          </div>
        );
      },
    },

    {
      id: "phase1_group",
      header: "Phase 1",
      columns: [
        {
          id: "jd_status",
          header: "JD Status",
          accessorKey: "jd_status",
          cell: ({ row }) => (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span style={{ color: "#e42d0d" }}>{row.original.jd_status || "-"}</span>
            </div>
          ),
        },
        {
          id: "final_status",
          header: "Section Status",
          accessorKey: "final_status",
          cell: ({ row }) => (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span>{row.original.final_status || "-"}</span>
            </div>
          ),
        },
        {
          id: "digi_sign_phase1",
          header: (
            <>
              Digital Signature <AiOutlineSignature size={20} />
            </>
          ),
          enableExport: false,

          cell: ({ row }) => {
            const pdfPath = row.original?.final_pdf_sign;

            if (pdfPath) {
              return (
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={() => {
                    viewImage(pdfPath);
                  }}
                  title="View Signed PDF"
                >
                  <i className="fa fa-file-pdf-o" />
                  <FaDownload size={19} /> View Signed
                </button>
              );
            }

            return (
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => {
                  setSelectedDigii(row.original || "");
                  getProceedingsDetailss(row.original.coll_code, row.original.noc_type, row.original.jd_status);
                }}
              >
                <i className="fa fa-file-pdf-o" /> Digi Sign
              </button>
            );
          },
        },
      ],
    },
    {
      id: "phase2_group",
      header: "Phase 2",
      columns: [
        {
          id: "jd_status_phase2",
          header: "JD Status",
          accessorKey: "jd_status_phase2",
          cell: ({ row }) => (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span>{row.original.jd_status_phase2 || "-"}</span>
            </div>
          ),
        },

        {
          id: "final_status_phase2",
          header: "Section Status",
          accessorKey: "final_status_phase2",
          cell: ({ row }) => (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span>{row.original.final_status_phase2 || "-"}</span>
            </div>
          ),
        },

        {
          id: "digi_sign_phase2",
          // size: 950,
          // minSize: 620,
          // maxSize: 650,
          header: (
            <>
              Digital Signature <AiOutlineSignature size={20} />
            </>
          ),
          enableExport: false,

          cell: ({ row }) => {
            const pdfPath = row.original?.final_pdf_sign_phase2;

            if (pdfPath !== null && pdfPath !== '' && pdfPath !== undefined) {
              return (
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={() => {
                    viewImage(pdfPath);
                  }}
                  title="View Signed PDF"
                >
                  <i className="fa fa-file-pdf-o" />
                  <FaDownload size={19} /> View Signed
                </button>
              );
            }

            return (
              <div className="d-flex align-items-center gap-2 flex-nowrap">

                <button
                  type="button"
                  className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                  onClick={() => {
                    setSelectedDigii(row.original || "");
                    getProceedingsDetailss(row.original.coll_code, row.original.noc_type, row.original.jd_status_phase2);
                  }}
                >
                  <i className="fa fa-file-pdf-o" /> Click here to Sign
                </button>
                {/* <button
                  type="button"
                  className="btn btn-secondary btn-sm d-flex align-items-center gap-1"
                  onClick={() =>
                    initiateESign({
                      nocType: row.original.noc_type,
                      collCode: row.original.coll_code,
                      backtoscreen: "DeficiencyFinal",
                    })
                  }
                >
                  E-Sign
                </button> */}
              </div>


            );
          },



        },


      ]
    },

  ];
  const [inspstatus, setInspStatus] = useState([]);
  function GetInspectionStatus() {
    const endpoint = userId === "section_admin" ? "getsectionadmindata" : "getInspectionStatus";
    // CommonAxiosGet(`${config.url.FAC_URL}${"getjdfinalstatus"}`).then((res) => {
    CommonAxiosGet(`${config.url.FAC_URL
      }${"getjdfinalstatusdeficiency"}`).then((res) => {
        setInspStatus(res?.data?.scode === "01" ? res.data.data || [] : []);
      });
  }

  const degreeUniFormik = useFormik({
    initialValues: { collegesTableData: [], nocType: "eop" },
    onSubmit: (values) => { },
  });

  const filteredInspectionStatus = degreeUniFormik.values.nocType
    ? inspstatus.filter((item) => String(item?.noc_type || "").toLowerCase() === String(degreeUniFormik.values.nocType).toLowerCase())
    : inspstatus;

  async function dskConfirmationFunc() {
    if (!pdfBas64) {
      failureAlert("No PDF available for signing.");
      return;
    }

    try {
      const collCode = selectedDigii?.coll_code;
      const nocType = selectedDigii?.noc_type;

      if (!collCode || !nocType) {
        failureAlert("Missing college code or NOC type.");
        return;
      }

      let postData = {
        path: config.url.FAC_URL + "updateJdFinalStatus",
        params: {
          collCode: collCode,
          nocType: nocType,
          finalPdf: pdfBas64,
          service: "Deficiency",
        },
      };

      digisignFunction(pdfBas64, "-1", postData, "", "FinalStatus", "Deficiency");
    } catch (error) {
      console.error("Error:", error);
      failureAlert("Digi sign failed.");
    }
  }

  useEffect(() => {
    GetInspectionStatus();
    DashBoardCounts(degreeUniFormik?.values?.nocType);

  }, [degreeUniFormik?.values?.nocType]);




  const [shiftAddr, setShiftAddr] = useState([]);
  function getShiftingAddDetailsss(collCode) {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails / ${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const shiftData = res?.data?.data || [];
          setShiftAddr(shiftData?.length > 0 && shiftData !== "No data found" ? shiftData : []);
          if (shiftData.length > 0) {
            const firstShift = shiftData[0];
            setShiftAddr({
              new_mandal: firstShift.mandal_name || firstShift.new_mandal,
              new_district: firstShift.new_dist || firstShift.new_district,
              new_pincode: firstShift.new_pincode,
              address_ofnew_location: firstShift.address_ofnew_location,
              shift_type: firstShift.shift_type,
              distance_from_existing: firstShift.distance_from_existing,
              justification: firstShift.justification,
            });
          }
        } else {
          setShiftAddr([]);
        }
      })
      .catch((err) => {
        setShiftAddr([]);
      });
  }
  const [getSurvey, setSurvey] = useState([]);
  const getSurveyNumberr = async (collCode) => {
    let url = config.url.FAC_URL + "getlandDetailsScrutinyShitfing/" + collCode;
    try {
      const res = await CommonAxiosGet(url);
      if (res && res.data.status === true) {
        setSurvey(res.data.data[0] || res.data.data || []);
      } else {
        setSurvey([]);
      }
    } catch (err) {
      console.error("Error fetching survey number:", err);
      setSurvey([]);
    }
  };
  const nocTypeOptions = Array.from(new Set((inspstatus || []).map((item) => item?.noc_type).filter((item) => item !== null && item !== undefined && String(item).trim() !== "")));

  const totalcondition = degreeUniFormik?.values?.nocType === "shifting" ? Dashboardcounts[0]?.phase2_total_count_shifting : Dashboardcounts[0]?.phase2_total_count;

  const PendingCondition = degreeUniFormik?.values?.nocType === "shifting" ? Dashboardcounts[0]?.phase2_pending_shifting : Dashboardcounts[0]?.phase2_pending;
  const TotalApproved = (Dashboardcounts[0]?.phase2_approved ?? 0) + (Dashboardcounts[0]?.phase2_conditional_approved ?? 0);


  return (
    <>
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <FormikProvider value={degreeUniFormik}>
          <Form onSubmit={degreeUniFormik.handleSubmit} className="affl-form">
            <bie.Row className="px-2 pt-3 mb-3 w-100">
              <h5 className="mb-3 innerheader-new">
                <span>Final Status</span>
              </h5>

              {/* <div
                style={{
                  minWidth: "280px",
                  maxWidth: "420px",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <label
                  className="form-label mb-0"
                  style={{
                    color: "#0f766e",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    marginBottom: 0,
                  }}
                >
                  Select NOC Type:
                </label>
                <Field
                  as="select"
                  name="nocType"
                  className="form-control"
                  onChange={degreeUniFormik.handleChange}
                  style={{
                    minWidth: "370px",
                    maxWidth: "420px",
                    borderRadius: "10px",
                    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
                  }}
                >
                  <option value="">--Select--</option>
                  {nocTypeOptions?.map((nocType) => (
                    <option key={nocType} value={nocType}>
                      {getNocFullName(nocType)}

                    </option>
                  ))}
                </Field>
              </div> */}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  flexWrap: "nowrap",
                }}
              >
                <label
                  className="form-label mb-0"
                  style={{
                    color: "#0f766e",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    marginBottom: 0,
                  }}
                >
                  Select NOC Type:
                </label>

                <Field
                  as="select"
                  name="nocType"
                  className="form-control"
                  onChange={degreeUniFormik.handleChange}
                  style={{
                    width: "350px", // or flex: 1
                    borderRadius: "10px",
                    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
                  }}
                >
                  <option value="">--Select--</option>
                  {nocTypeOptions?.map((nocType) => (
                    <option key={nocType} value={nocType}>
                      {getNocFullName(nocType)}
                    </option>
                  ))}
                </Field>
              </div>
              <bie.Col xs={12}>
                {filteredInspectionStatus?.length > 0 ? (
                  <>

                    <div className="dashboard-summary mt-4">

                      <div className="kpi-card total-card">
                        <div className="kpi-icon">
                          <i className="bi bi-grid-3x3-gap-fill"></i>
                        </div>

                        <div className="kpi-content">
                          <div className="kpi-title">Total Applications</div>
                          <div className="kpi-value">{totalcondition}</div>
                        </div>



                      </div>


                      {degreeUniFormik?.values?.nocType !== "shifting" && (
                        <div className="kpi-card approved-card">

                          <div className="card-heading">
                            <i className="bi bi-check-circle-fill me-2"></i>
                            Approved  ({TotalApproved})
                          </div>

                          <div className="split-section">

                            <div className="split-item">
                              <div className="split-title">
                                Approved
                              </div>

                              <div className="split-value">
                                {Dashboardcounts[0]?.phase2_approved}
                              </div>
                            </div>

                            <div className="split-line"></div>

                            <div className="split-item">
                              <div className="split-title">
                                Conditional
                              </div>

                              <div className="split-value">
                                {Dashboardcounts[0]?.phase2_conditional_approved}
                              </div>
                            </div>

                          </div>

                        </div>
                      )}




                      {/* <div className={`kpi-card ${headingCardClass}`}>

                        <div className="kpi-icon">
                          <i
                            className={
                              degreeUniFormik?.values?.nocType === "shifting"
                                ? "bi bi-check-circle-fill"
                                : "bi bi-exclamation-triangle-fill"
                            }
                          ></i>
                        </div>

                        <div className="kpi-content">
                          <div className="kpi-title">
                            {Headingcondition}
                          </div>

                          <div className="kpi-value">
                            {Headingvalue}
                          </div>
                        </div>

                      </div> */}




                      <div className="kpi-card pending-card">

                        <div className="kpi-icon">
                          <i className="bi bi-hourglass-split"></i>
                        </div>

                        <div className="kpi-content">
                          <div className="kpi-title">
                            Pending
                          </div>

                          <div className="kpi-value">
                            {PendingCondition}
                          </div>
                        </div>

                      </div>

                      {degreeUniFormik?.values?.nocType === "shifting" && (

                        <div className="kpi-card rejected-card">

                          <div className="kpi-icon">
                            <i className="bi bi-x-circle-fill"></i>
                          </div>

                          <div className="kpi-content">
                            <div className="kpi-title">
                              Rejected
                            </div>

                            <div className="kpi-value">
                              {Dashboardcounts[0]?.phase1_shifting_reject}
                            </div>
                          </div>

                        </div>


                      )}
                    </div>

                    <div className="table-responsive">
                      <CommonReactTable
                        data={filteredInspectionStatus}
                        columns={Columns}
                        filename="AsiignInspectionToByUniversity"
                        // headerName={getNocFullName(
                        //   "Deficiency Final Report",
                        //   degreeUniFormik?.values?.nocType
                        // )}
                        headerName={`Deficiency Final Report${degreeUniFormik?.values?.nocType
                          ? ` - ${getNocFullName(degreeUniFormik.values.nocType)}`
                          : ""
                          }`}
                        showFooter={false}
                        showPagination={false}
                        showExcel={true}
                        showPrint={false}
                        excelFileName="Inspection Status"
                      />
                    </div>
                  </>
                ) : (
                  <center className="text-danger h6">*** No Data Found ***</center>
                )}
              </bie.Col>
              <bie.Modal show={showDefShiftingModal} onHide={() => setShowDefShiftingModal(false)} size="xl" scrollable>
                <bie.Modal.Header closeButton>
                  <bie.Modal.Title>{selectedDefRow?.noc_type === "shifting" && "Shifting Scrutiny Report"}</bie.Modal.Title>
                </bie.Modal.Header>
                <bie.Modal.Body>
                  {selectedDefRow?.noc_type === "shifting" && (
                    <CollegeReport apiData={pdfData} apiData2={pdfDataa} rowData={selectedDefRow} getOverallData={getOverallData} getSurvey={getSurvey} newAddData={shiftAddr} />
                  )}
                </bie.Modal.Body>
              </bie.Modal>


              <bie.Modal show={showPdffModal} onHide={() => setShowPdffModal(false)} size="xl" centered>
                <bie.Modal.Header closeButton>
                  <bie.Modal.Title>Proceedings PDF Previewd</bie.Modal.Title>
                </bie.Modal.Header>

                <bie.Modal.Body style={{ height: "80vh", padding: 0 }}>
                  {pdfBas64 && <iframe title="PDF Preview" src={`data: application/pdf;base64,${pdfBas64}`} width="100%" height="100%" style={{ border: "none" }} />}
                </bie.Modal.Body>

                <bie.Modal.Footer>
                  <div className="d-flex justify-content-end gap-2 mt-3">

                    <button type="submit" className="btn btn-primary sign-btn" onClick={dskConfirmationFunc}>

                      Digi Sign
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary sign-btn"
                      onClick={() =>
                        initiateESign({
                          nocType: selectedDigii.noc_type,
                          collCode: selectedDigii.coll_code,
                          backtoscreen: "DeficiencyFinal",
                        })
                      }
                    >
                      E-Sign
                    </button>
                  </div>
                </bie.Modal.Footer>
              </bie.Modal>
              {/* <bie.Modal show={showPdffModal} onHide={() => setShowPdffModal(false)} size="xl" centered>
                <bie.Modal.Header closeButton>
                  <bie.Modal.Title>Proceedings PDF Preview</bie.Modal.Title>
                </bie.Modal.Header>

                <bie.Modal.Body style={{ height: "80vh", padding: 0 }}>
                  {pdfBas64 ? (
                    <iframe
                      title="PDF Preview"
                      src={`data:application/pdf;base64,${pdfBas64}`}
                      width="100%"
                      height="100%"
                      style={{ border: "none" }}
                    />
                  ) : (
                    <div style={{ textAlign: "center", padding: "20px" }}>Loading PDF...</div>
                  )}
                </bie.Modal.Body>

                <bie.Modal.Footer>
                  <button type="button" className="btn btn-primary" onClick={dskConfirmationFunc}>
                    Digi Sign
                  </button>
                </bie.Modal.Footer>
              </bie.Modal> */}

            </bie.Row>
          </Form>
        </FormikProvider>
      </bie.Container>
    </>
  );
}
